import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderDatasourcesComponent } from './dynamic-page-builder-datasources.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderDatasourcesComponent } from './datasources/page-builder-datasources.component';
import { MDPageBuilderDatasourcePickerComponent } from './md-datasources-picker/md-page-builder-datasource-picker.component';
import {CdkTreeModule} from '@angular/cdk/tree';

@NgModule({
    declarations: [
        PageBuilderDatasourcesComponent, DynamicPageBuilderDatasourcesComponent,
        MDPageBuilderDatasourcePickerComponent 
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        CdkTreeModule,
    ],
    entryComponents: [
        DynamicPageBuilderDatasourcesComponent,
        MDPageBuilderDatasourcePickerComponent
    ]
})
export class PageBuilderDatasourcesModule {}